export default "__VITE_ASSET__B4Z2eqNq__"